<template>
  <v-dialog v-model="show" :max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">
          <span v-if="qrToPrint.length != 0"> Reimprimir QR's ({{ qrToPrint.length }})</span>
          <span v-else> Imprimir QR's </span>
        </span>
        <v-btn icon dark @click="show = false" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 bg-app">
        <v-container>
          <v-form ref="form">
            <v-row v-if="qrToPrint.length != 0">
              <v-col class="pb-0">
                <v-autocomplete
                  label="Tipo de etiqueta"
                  outlined
                  dense
                  item-text="name"
                  :items="containerTypes"
                  :rules="validation('tipo')"
                  v-model="containerType"
                  class="white rounded-lg"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" sm="6" class="pb-0">
                <v-autocomplete
                  label="Tipo de etiqueta"
                  outlined
                  dense
                  item-text="name"
                  :items="containerTypes"
                  :rules="validation('tipo')"
                  v-model="containerType"
                  class="white rounded-lg"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  label="Cantidad de etiquetas"
                  type="number"
                  outlined
                  dense
                  :rules="validation('cantidad')"
                  v-model="containerQuantity"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 bg-white">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="show = false"
          :disabled="isLoading"
          class="px-4"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          rounded
          @click="generateQrs"
          :loading="isLoading"
          elevation="0"
          class="px-8"
        >
          Generar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import { requiredValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    containerQuantity: null,
    containerType: null,
    containerTypes: [
      {
        name: "Etiqueta qPCR",
        value: "QPCR",
      },
      {
        name: "Etiqueta híbrido",
        value: "HYBRID",
      },
      {
        name: "Etiqueta tradicional",
        value: "CLASSIC",
      },
    ],
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("container", ["qrToPrint"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("container", ["generateQRlabels", "regenerateQRlabels"]),
    validation(name) {
      return requiredValidation(name);
    },
    async generateQrs() {
      try {
        if (this.$refs.form.validate()) {
          this.isLoading = true;
          let payload = {
            containersType: this.containerType,
            containersQuantity: this.containerQuantity,
          };
          if (this.qrToPrint.length != 0) {
            payload.containerToGenerate = this.qrToPrint;
            let response = await this.regenerateQRlabels(payload);
            this.downloadPDF(response.document.url);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "QR's generados",
              timeout: 5000,
            });
            this.$emit("fetchData");
          } else {
            let response = await this.generateQRlabels(payload);
            this.downloadPDF(response.document.url);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "QR's generados",
              timeout: 5000,
            });
            this.$emit("fetchData");
          }
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal, intente de nuevo",
          timeout: 5000,
        });
      }
      this.isLoading = false;
    },
    downloadPDF(value) {
      if (value.length > 0) {
        var a = document.createElement("a");
        a.href = value;
        let fileName = value.split("/").pop();
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(value);
        a.remove();
      }
    },
  },
};
</script>
